import Box from "@mui/material/Box";

const PROGRESS_BAR_HEIGHT = 6;

const OnboardingChecklistProgressBar = ({
  progress,
  sx,
  barColor = "text.primary",
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: PROGRESS_BAR_HEIGHT,
        borderRadius: "999px",
        bgcolor: "grey.300",
        overflow: "hidden",
        ...sx,
      }}
    >
      <Box
        sx={{
          width: `${progress}%`,
          height: "100%",
          bgcolor: barColor,
          borderRadius: "999px",
          transition: "all 0.5s ease",
        }}
      />
    </Box>
  );
};

export default OnboardingChecklistProgressBar;
